import t from"@emotion/styled";import{setRadius as r}from"../../utils/generateStyles.js";import{IconButtonSizes as i,retrieveButtonVariant as e}from"./IconButton.utils.js";const n=t.button`
  label: icon-button;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  border-style: solid;
  outline-width: 0px;
  border-width: 0px;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  ${o=>r(o.radius)}
  ${o=>i(o.size)}
  ${o=>e(o.variant,o.color)}
`;export{n as default};
